import { mapValues } from 'lodash';
import {
  AnswerByCategoryPinLayoutTemplate,
  AnswerByCategoryTeacherPin,
  CategoryAreaPinComponentSettings,
} from '../../models';
import { isCategoryAreaPinComponent } from '../assertions';
import { PinCreationParams } from './pin-helper-types';

export const newAnswerByCategoryPin = (
  layout: AnswerByCategoryPinLayoutTemplate
): PinCreationParams<AnswerByCategoryTeacherPin> => {
  const basePin: PinCreationParams<AnswerByCategoryTeacherPin> = {
    type: 'ANSWER_BY_CATEGORY',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      backgroundImage: layout.backgroundImage,
      questionId: layout.layoutParts.TITLE?.id,
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
    },
    teacherSettings: {},
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
  };

  if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layout.backgroundTransparency;
  }

  return basePin;
};

export function categoriesForPin(
  pin: AnswerByCategoryTeacherPin
): CategoryAreaPinComponentSettings['categories'][number][] {
  const categoryComponent = pin.pinComponents.find(isCategoryAreaPinComponent);
  return categoryComponent?.settings.categories ?? [];
}
